import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
class Flowpaper extends Component {
    static propTypes = {
      // url: PropTypes.string,
      data: PropTypes.object,
      onCloseFlowpaper: PropTypes.func,
      isOpen: PropTypes.bool
    };

    constructor(props) {
      super(props);
      this.pdfDoc = null;
      this.state = {
        isLoading: true
      };

      this.onMyFrameLoad = this.onMyFrameLoad.bind(this);
    }

    onMyFrameLoad = () => {
      this.setState({
        isLoading: false
      });
    }

    //  getDocumentUrl =(document) => {
    //    const numPages = '10';
    //    let url = 'http://pdfviewer.siteoneservices.com/aspnet/services/view.ashx?doc={doc}&format={format}&page=[*,0],{numPages}';
    //    url = url.replace('{doc}',document);
    //    url = url.replace('{numPages}',numPages);
    //    return url;
    //  }

    // onLoadDocument = () => {

    // };

    onCloseDialog = () => {
      const { onCloseFlowpaper } = this.props;
      if (onCloseFlowpaper) {
        onCloseFlowpaper();
      }
    };

    render() {
      const {isLoading} = this.state;
      return (
        <Modal centered='true' show={this.props.isOpen} dialogClassName='pdf-flowpaper-dialog'>
          <Modal.Body>
            <div className='frame-container'>
              <button
                type='button'
                className='iframe-button close-button'
                onClick={this.onCloseDialog}
              >
                  &times;
              </button>

              {isLoading && (
                <div className='pdf-preview-loading'>
              Reading file. Please wait...
                </div>
              )}
              {/* {this.props.data && this.props.data.pdfViewerFileName 
              ? 
              <iframe allowFullScreen 
              onLoad={this.onMyFrameLoad} 
              title='documentViewer' 
              placeholder='documentViewer' 
              src={`https://pdfviewer.siteoneservices.com/aspnet/split_document.aspx?doc=${this.props.data.pdfViewerFileName}`} 
              style={{width: '100%', 
                      height: '100vh', 
                      top: 0, 
                      left: 0, 
                      bottom: 0, 
                      right: 0, 
                      border: 'none', 
                      margin: 0, 
                      padding: 0}}/>
              : */}
              {this.props.data && this.props.data.url && 
              <iframe allowFullScreen 
              onLoad={this.onMyFrameLoad} 
              title='documentViewer' 
              placeholder='documentViewer' 
              src={this.props.data.url} 
              style={{width: '100%', 
                      height: '100vh', 
                      top: 0, 
                      left: 0, 
                      bottom: 0, 
                      right: 0, 
                      border: 'none', 
                      margin: 0, 
                      padding: 0}} />}
            </div>
          </Modal.Body>
        </Modal>
      );
    }
}

export default Flowpaper;



// WEBPACK FOOTER //
// ./src/components/Flowpaper/index.js